module.exports = __webpack_public_path__ + "img/sample-report-03@3x.2244a7a5.png";